<template>
  <div v-if="is_current_admin_profile_needs_an_update">
    <modal
      name="alert_admin_to_update_profile_modal"
      :width="'600px'"
      :height="'auto'"
      :adaptive="true"
      style="z-index:9999;"
    >
      <div class="modal_close_cont">
        <button
          @click="$modal.hide('alert_admin_to_update_profile_modal')"
        ></button>
      </div>
      <div style="text-align:center; padding:20px;">
        <div style="font-size:16px; font-weight:500;">
          {{ T__("Booking Widget Info Preview") }}
        </div>
        <div class="gravatar-name-onboarding">
          <img :src="admin_details.profile_picture" width="75" />
          <div class="display-name">{{ admin_details.display_name }}</div>
          <div class="event-type-name" v-if="service_details.name">
            {{ service_details.name }}
          </div>
          <div class="event-type-duration" v-if="service_details.duration">
            {{ service_details.duration | mins_to_str }}
          </div>
        </div>
        <div style="font-size:16px;margin-bottom: 20px;line-height: 1.6em;">
          {{ T__("Want to change your Avatar or Display name?") }} <br />
          {{ T__("Go to") }}
          <router-link style="font-size:16px;" to="/settings/profile"
            >{{ T__("Settings &rsaquo; Profile") }}
          </router-link>
        </div>
        <a @click="dismiss_notice">{{ T__("Nope, everything looks good") }}</a>
      </div>
    </modal>
    <a @click="check_and_show_alert_to_admin" style="display:none;"
      >Lorem ipsum... Admin profile check</a
    >
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: {
    service_details: {}
  },
  computed: {
    is_current_admin_profile_needs_an_update() {
      if (this._isEmpty(this.admin_details)) {
        return false;
      }

      let admin_details = this.admin_details;
      if (!admin_details.id) {
        return false;
      }

      let current_admin_notices = this.$store.getters.get_current_admin_notices;

      if (current_admin_notices == null) {
        //not yet loaded
        return false;
      }

      if (
        current_admin_notices.hasOwnProperty(
          "alert_admin_to_update_profile_for_name_v2"
        ) &&
        current_admin_notices.alert_admin_to_update_profile_for_name_v2.hasOwnProperty(
          "status"
        ) &&
        current_admin_notices.alert_admin_to_update_profile_for_name_v2
          .status == "dismissed"
      ) {
        return false;
      }

      return true;
    },
    admin_details() {
      return this.$store.getters.get_current_admin_details;
    }
  },
  methods: {
    show_alert_admin_to_update_profile_modal() {
      this.$modal.show("alert_admin_to_update_profile_modal");
    },
    async check_and_show_alert_to_admin() {
      await this.$store.dispatch("get_settings_and_defaults", {
        background_call: true
      }); //to get latest data and show alert.
      if (this.is_current_admin_profile_needs_an_update) {
        this.show_alert_admin_to_update_profile_modal();
      }
    },
    dismiss_notice() {
      this.$modal.hide("alert_admin_to_update_profile_modal");

      let wpcal_request = {};
      let action = "update_admin_notices";
      wpcal_request[action] = {
        alert_admin_to_update_profile_for_name_v2: { status: "dismissed" }
      };
      let action2 = "get_admin_notices";
      wpcal_request[action2] = "dummy__";

      let post_data = {
        action: "wpcal_process_admin_ajax_request",
        wpcal_request: wpcal_request
      };

      axios
        .post(window.wpcal_ajax.ajax_url, post_data)
        .then(response => {
          //console.log(response);
          this.notify_single_action_result(response.data[action], {
            success_msg: this.T__("Successfully dismissed.")
          });
          if (
            response.data[action2].status === "success" &&
            response.data[action2].hasOwnProperty("current_admin_notices")
          ) {
            this.$store.commit("set_store_by_obj", {
              current_admin_notices:
                response.data[action2].current_admin_notices
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  mounted() {
    setTimeout(() => this.check_and_show_alert_to_admin(), 1000);
  }
};
</script>

<style scoped>
.gravatar-name-onboarding {
  background-image: url("../../assets/images/gravatar-name-onboarding.jpg");
  width: 378px;
  height: 313px;
  margin: 20px auto;
  position: relative;
  font-family: "Rubik";
}
.gravatar-name-onboarding img {
  position: absolute;
  border-radius: 50%;
  left: 91px;
  top: 81px;
}
.gravatar-name-onboarding .display-name {
  position: absolute;
  text-transform: uppercase;
  left: 91px;
  top: 167px;
  width: 120px;
  height: 18px;
  text-align: left;
}
.gravatar-name-onboarding .event-type-name {
  position: absolute;
  left: 91px;
  top: 198px;
  font-size: 22px;
}
.gravatar-name-onboarding .event-type-duration {
  position: absolute;
  left: 116px;
  top: 237px;
  font-size: 14px;
}
button {
  padding: 13px;
  font-size: 16px;
  background-color: #567bf3;
  color: #fff;
  border: 0;
  border-radius: 5px;
  outline: 0;
  cursor: pointer;
  width: 300px;
  margin: 30px auto 20px;
}
</style>
